module.exports = __webpack_public_path__ + "img/third_cloud.e033fc22.png";